import { apiClient } from "../base-client";

export interface BuilderPartnerPalette {
  id: string;
  name: string;
  description: string | null;
  collectionKey: string;
  displayMediaId: string | null;
  displayImageUrl: string | null;
  position: number | null;
}

export async function getCommunityPalettes(
  communityId: string,
): Promise<BuilderPartnerPalette[]> {
  const { data } = await apiClient.get<BuilderPartnerPalette[]>(
    `v1/builder-partners/communities/${communityId}/palettes`,
  );
  return data;
}
